export default __webpack_public_path__ + "static/media/Pistol_8.42f5da6e.png";